module.exports = __webpack_public_path__ + "static/media/map.dc9149ca.svg";